import { api } from '../../api/config';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react'
import Loader from '../../components/loader/Loader';
import Rows from '../../layout/builder/Rows';
import { useSearchParams } from 'react-router-dom';
// import { Helmet } from 'react-helmet-async';

import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import ShareIcon from '@mui/icons-material/Share';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

const shareUrls = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=`,
    instagram: `https://www.instagram.com/`, // Instagram doesn’t have a direct share API
};

const actions = [
    { icon: <FacebookIcon />, name: 'Facebook', url: shareUrls.facebook },
    { icon: <LinkedInIcon />, name: 'LinkedIn', url: shareUrls.linkedin },
    { icon: <InstagramIcon />, name: 'Instagram', url: shareUrls.instagram },
];

export default function BlogContent() {
    const { id } = useParams();
    const [blog, setBlog] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchParams] = useSearchParams();
    const reduxLanguage = useSelector(state => state.language.language); // Always call hooks first!
    const urlLanguage = searchParams.get("lang");

    const language = urlLanguage || reduxLanguage;

function safeDecode(str) {
    if (!str.includes("&")) return str; // If no HTML entities, return as is
    var doc = new DOMParser().parseFromString(str, 'text/html');
    return doc.documentElement.textContent;
}

    const navigate = useNavigate();
    const path = window.location.pathname.split('/');

    const [blogId, setBlogId] = useState(null);
    const [helmet, setHelmet] = useState({ title: '', description: '', image: '', url: '' });
    const getData = () => {
        setLoading(true);
        api.post('/admin/getData', { lang: language, slug: id, id: blogId })
            .then(res => {
                if (res.data.success === true) {
                    if (path[2] !== res.data.data.slug) {
                        navigate(`../blogs/${res.data.data.slug}`);
                    } else {
                        setHelmet({
                            title: res?.data?.data?.title,
                            description: res?.data?.data?.description,
                            image: res?.data?.data?.image,
                            url: window.location.href
                        });
                        setBlogId(res?.data?.data?.blog_id)
                        const decodedData = safeDecode(res.data.data.content);
                        const jsonData = JSON.parse(decodedData);
                        setBlog(jsonData);
                    }
                }
            })
            .finally(() => {
                setLoading(false);
            })
    }

    useEffect(() => {
        getData();
        window.scrollTo(0, 0);
        // eslint-disable-next-line
    }, [id, language]);

    return (
        !loading ?
            <>
                <head>
                    <title>{helmet.title}</title>
                    <meta name="description" content={helmet.description} />
                    <meta property="og:title" content={helmet.title} />
                    <meta property="og:description" content={helmet.description} />
                    <meta
                        property="og:image"
                        content={
                            helmet.image && helmet.image !== ''
                                ? (helmet.image.endsWith('.webp')
                                    ? 'https://fundway.com/images/2025/Blog-picture.jpg'
                                    : helmet.image)
                                : 'https://fundway.com/images/2025/default-image.jpg'
                        }
                    />

                    <meta property="og:url" content={helmet.url} />
                    <meta property="og:type" content="article" />
                </head>
                {
                    blog.map((row) => (
                        <Rows
                            key={row.id}
                            id={row.id}
                            row={row}
                        />
                    ))
                }
                <SpeedDial
                    ariaLabel="Share Blog"
                    icon={<ShareIcon />}
                    direction="up"
                    sx={{ position: 'fixed', bottom: '20px', right: '20px', '.MuiSpeedDial-fab': { backgroundColor: '#002856' } }}
                >
                    {actions.map((action) => (
                        <SpeedDialAction
                            key={action.name}
                            icon={action.icon}
                            tooltipTitle={action.name}
                            onClick={() => window.open(action.url + encodeURIComponent(window.location.href), '_blank')}
                        />
                    ))}
                </SpeedDial>
            </>
            :
            <Loader state={loading} />
    )
}